import { v1ApiClient } from '@/services';
import type { Operation, Schema } from '@/shared/api/generated';

type UpdateStudioItemTitleOperation = Operation<'UpdateHeySynclyStudioItemTitle'>;

export type UpdateStudioItemTitleParams =
  UpdateStudioItemTitleOperation['parameters']['path'] &
  UpdateStudioItemTitleOperation['requestBody']['content']['application/json'];

export type UpdateStudioItemTitleResponse = Schema<'HeySynclyStudioItem'>;

export const updateStudioItemTitle = ({
  item_id,
  ...body
}: UpdateStudioItemTitleParams): Promise<UpdateStudioItemTitleResponse> =>
  v1ApiClient
    .patch(`/hey-syncly/studio/items/${item_id}/title`, body)
    .then((res) => res.data);
